export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
export const SET_CURRENT_MCD = 'SET_CURRENT_MCD';
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const SET_REGISTER_STATE = 'SET_REGISTER_STATE';
export const SET_MCD_REGO_FORM = 'SET_MCD_REGO_FORM';
export const SET_REGISTRATION_SUCCESS_STATE = 'SET_REGISTRATION_SUCCESS_STATE';
export const UPDATE_EVENT_FAQS = 'UPDATE_EVENT_FAQS';
export const UPDATE_EVENT_SPEAKERS = 'UPDATE_EVENT_SPEAKERS';
export const UPDATE_EVENT_SESSIONS = 'UPDATE_EVENT_SESSIONS';
export const UPDATE_EVENT_TICKETS = 'UPDATE_EVENT_TICKETS';
export const UPDATE_EVENT_SPONSORS = 'UPDATE_EVENT_SPONSORS';
